import { useEffect } from "react";

import { useAuthValidate } from "features/auth/fabric";
import Auth from "areas/auth/ui/Auth";


export default function Signup() {
	const auth = useAuthValidate();

	useEffect(() => {
		auth.redirect.confirm();
	}, [auth._]);

	return <Auth.SignUp />;
}